// extracted by mini-css-extract-plugin
module.exports = {"button":"styles-module__button___13kqW","icon":"styles-module__icon___1G2sw","smaller":"styles-module__smaller___4Kf87"};